module.exports = __webpack_public_path__ + "da6e010b5edfb3ab8822fa2253610735.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yeoman.png
// module id = 957
// module chunks = 0